<template>
  <!-- Product Page Wrapper -->
  <div class="product-page-wrapper section-padding-bottom-md">
    <div class="container">
      <!-- Shop Breadcrumb -->
      <breadcrumb :addRoute="{name:detailData.name,path:$route.path}"></breadcrumb>
      <!--// Shop Breadcrumb -->

      <!-- Product Details Inner -->
      <div class="product-details">
        <!-- Product Details Left -->
        <div class="product-details-left">

          <div class="product-details-images slider-navigation-2" >
            <a class="text-center" :href="item" v-for="(item,index) in detailData.albumPics" :title="detailData.name">
              <div class="row justify-content-center align-items-center ">
                <img :src="detailData.thumbnailPics[index]" :alt="detailData.description">
              </div>
            </a>
          </div>
          <div class="text-center ">
            <p class="color-black"><i class="fa fa-search"></i> <span> CLICK IMAGE TO ZOOM</span></p>
            <p class="social-icons"> <share></share></p>
            <p><span>Altervative Views:</span></p>

          </div>
          <div class="product-details-thumbs slider-navigation-2 text-center">
            <img :src="item"  v-for="(item,index) in detailData.smallPics"  :key="index" >
          </div>
        </div>
        <!--// Product Details Left -->

        <!-- Product Details Right -->
        <div class="product-details-right">
          <h5 class="product-title">{{detailData.name}}</h5>

          <p>{{detailData.description}}</p>

     <!--
     <div class="price-box">
            <span class="pricebox-price">$ {{detailData.price}}</span>
          </div>-->

          <div class="product-details-quantity">
            <!--
            <div class="quantity-select">
              <input type="text" value="1">
            </div>
            -->
            <a href="#product-reviews"  data-toggle="modal" data-target="#contactUsModal" class="add-to-cart-button ml-0">
              <span>Contact Us</span>
            </a>

          </div>

          <div class="product-details-size">
            <span>Style # : {{detailData.productSn}}</span>
          </div>
          <div class="product-details-size">
            <span>Dimensions : {{detailData.size}}</span>
          </div>

          <div class="product-details-categories">
            <span>Main Material :  {{detailData.mainMaterial}}</span>
          </div>

          <div class="product-details-tags">
            <span>Lining Material :  {{detailData.liningMaterial}}</span>
          </div>

          <div class="product-details-tags">
            <span>Hardware :  {{detailData.hardware}}</span>
          </div>
          <colors :productSn="detailData.productSn"></colors>
          <div class="product-details-socialshare">
            <span>Share :</span>
            <share></share>
          </div>
        </div>
        <!--// Product Details Right -->

      </div>

      <div class="product-descripton-review" >
        <ul class="nav" id="product-description-review" >
          <li class="nav-item">
            <span class="like-products-title">You May Also Like</span>
          </li>
        </ul>

        <div class="row justify-content-center shop-page-products products-wrapper" v-show="likeTotalPage>0">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 justify-content-center">
              <span class="fa fa-chevron-left color-black" style="position:relative;top:50%;float: right;font-size:36px;" @click="preLike()">
              </span>
          </div>
          <!-- Single Product -->
          <div class="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12" v-for="product in productList">
            <div class="product-item">

              <div class="product-item-images">
                <a :href="'/fashion-handbags/'+product.productCategoryName+'/'+product.productSn" :title="product.name"  class="product-item-image-inner">
                  <img :src="product.pic" :alt="product.name" style="width: 100%;height: auto;">
                </a>
                <a :href="'/fashion-handbags/'+product.productCategoryName+'/'+product.productSn" :title="product.name" class="add-to-cart-button">
                  <span>VIEW</span>
                </a>
              </div>

              <div class="product-item-content">
                <div class="product-item-content-left">
                  <h5><a :href="'/fashion-handbags/'+product.productCategoryName+'/'+product.productSn" :title="product.name">{{product.name}}</a></h5>
                </div>
              </div>

            </div>
          </div>
          <!--// Single Product -->

          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 justify-content-center">
              <span style="position:relative;top:50%;font-size:36px;" class="fa fa-chevron-right color-black" @click="nextLike()">
              </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 模态框（Modal） -->
    <div class="modal fade" id="contactUsModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">

            <form ref="refForm" id="detailForm" onsubmit="return false">
              <div class="form-group">
                <label for="memberNickName">Name *</label>
                <input type="text" class="form-control is-invalid" required v-model="review.memberNickName" id="memberNickName" aria-describedby="memberNickNameHelp" >
              </div>

              <div class="form-group">
                <label for="eMail">E-mail *</label>
                <input type="email" class="form-control is-invalid" required v-model="review.eMail" id="eMail" aria-describedby="eMailHelp" >
              </div>

              <div class="form-group">
                <label for="tel">Phone</label>
                <input type="tel" class="form-control"  v-model="review.tel" id="tel" aria-describedby="telHelp" >
              </div>

              <div class="form-group">
                <label for="content">You Review</label>
                <textarea class="form-control" id="content"  v-model="review.content"  rows="3"></textarea>
              </div>

              <button type="submit" class="btn btn-primary  float-right" >SUBMIT</button>
              <button type="button" class="btn btn-default float-right" data-dismiss="modal">CLOSE</button>
            </form>

          </div>
          <div class="modal-footer">
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>

   <message-tips ref="rMessageTips"></message-tips>

  </div>

  <!--// Product Page Wrapper -->
</template>

<script>
    import request from '@/utils/request'
    import breadcrumb from '@/components/breadcrumb'
    import review from '@/components/review'
    import share from '@/components/share'
    import {setDocument} from '@/utils/documentSEO'
    import messageTips from '@/components/MessageTips'
    import colors from './color'
    const defaultValue = {
      star:5,
      content:'',
      eMail:'',
      memberNickName:'',
      productId:0,
      contentPath:'',
      tel:''
    }
    export default {
        name: "detail",
        components:{
          breadcrumb,review,share,messageTips,colors
        },
        data(){
          return {
            detailData:{
              albumPics:""
            },
            review:Object.assign({}, defaultValue),
            count: '',
            timer: null,
            productList:[],
            likePageNum:1,
            likeTotalPage:0
          }
        },
        methods:{
          pics(){
            return this.detailData.albumPics.split(",")
          },
          submitReview(){
            let _this =this
            this.review.contentPath = window.location.href
            request({
              url:'/pms-comment/save',
              method:'POST',
              data:this.review
            }).then(res=>{

            })


            $("#contactUsModal").modal('hide')
            _this.$refs.rMessageTips.memberNickName = _this.review.memberNickName
            _this.$refs.rMessageTips.setTimer()
            _this.review = Object.assign({}, defaultValue)

          },
          loadLikeProducts(){
            let _this = this
            let reg = new RegExp("large-size","g");
            request({
              url:'/product/also-like/'+this.$route.params.id,
              params:{pageNum: _this.likePageNum, pageSize: 5}
            }).then(res=>{
              if(res.data.code===200) {
                _this.productList = res.data.data.list
                _this.likeTotalPage = res.data.data.totalPage
                _this.productList.forEach((item, index) => {
                  item.pic = item.pic.replace(reg, 'thumbnail-size')
                })
              }
            })
          },
          preLike(){
            if(this.likePageNum>1){
              this.likePageNum--
              this.loadLikeProducts()
            }
          },
          nextLike(){
            if(this.likePageNum<this.likeTotalPage){
              this.likePageNum++
              this.loadLikeProducts()
            }
          }
        },
       created(){
          const _this = this
           request({
             url:'/product/updateInfo/'+this.$route.params.id
           }).then(res=>{
             if(res.data.code===200){
               _this.detailData = res.data.data
               //thumbnail-size
               let reg = new RegExp("large-size","g");
               _this.detailData.albumPics=_this.detailData.pic+","+_this.detailData.albumPics
               _this.detailData.smallPics = _this.detailData.albumPics.replace(reg,'small-size').split(",")
               _this.detailData.thumbnailPics = this.detailData.albumPics.replace(reg,'thumbnail-size').split(",")
               _this.detailData.albumPics = _this.detailData.albumPics.split(",")

               setDocument(_this.detailData.name,_this.detailData.keywords,_this.detailData.description)

              setTimeout(function(){
               $('select').niceSelect();
               /* Product Details Images */
               $('.product-details-images').slick({
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 autoplay: false,
                 autoplaySpeed: 5000,
                 dots: false,
                 infinite: true,
                 centerMode: true,
                 centerPadding: 0,
                 prevArrow: '<span class="slider-navigation slider-navigation-prev"><i class="fa fa-caret-left"></i></span>',
                 nextArrow: '<span class="slider-navigation slider-navigation-next"><i class="fa fa-caret-right"></i></span>',
                 asNavFor: '.product-details-thumbs'
               });
               $('.product-details-thumbs').slick({
                 slidesToShow: 5,
                 slidesToScroll: 1,
                 autoplay: false,
                 autoplaySpeed: 5000,
                 dots: false,
                 infinite: true,
                 focusOnSelect: true,
                 centerMode: false,
                 centerPadding: 0,
                 useTransform:true,
                 prevArrow: '<span class="slider-navigation slider-navigation-prev"><i class="fa fa-caret-left"></i></span>',
                 nextArrow: '<span class="slider-navigation slider-navigation-next"><i class="fa fa-caret-right"></i></span>',
                 asNavFor: '.product-details-images'
               });
        /*       if(_this.detailData.albumPics.length<5){
                  setTimeout(function() {
                    $('.slick-track')[1].style.left='0px'
                  },500);
               }*/
                _this.loadLikeProducts()


                /* Product Popup */
               $('.product-details-images').magnificPopup({
                 type:'image',
                 delegate: 'a',
                 gallery:{
                   enabled:true
                 }
               });
              },100);

             }
           })

       },
      mounted(){
        let _this = this

        let form = document.getElementById("detailForm");
        form.addEventListener("submit", function(event) {
          if (form.checkValidity() === true) {
            _this.submitReview()
          }
        }, false);
      }
    }
</script>

<style scoped>

</style>
